
import { NgModule, Component, Pipe, OnInit } from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as lodash from 'lodash';
import { Router } from '@angular/router';
import { AuthGuardService } from '../../services/auth-guard.service';
import { ViewChild } from '@angular/core';
import { MessageComponent } from '../messages/message.component';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.scss']
})
export class LoginFormComponent implements OnInit {
  loginForm: FormGroup;
  email: FormControl;
  password: FormControl;
  attempts: Number;
  captchaError: Boolean;
  captchaSucess: Boolean;

  @ViewChild(MessageComponent) public messageComponent: MessageComponent;


  public constructor(
    private http: HttpClient, private router: Router,
    private auth: AuthGuardService) { }

  ngOnInit() {
    this.createFormControls();
    this.createForm();
    this.attempts = 0;
    this.captchaSucess = false;
  }

  createFormControls() {
    this.email = new FormControl(
      '', [Validators.required, Validators.pattern("[^ @]*@[^ @]*")]);
    this.password = new FormControl('', [Validators.required]);
  }

  createForm() {
    this.loginForm =
      new FormGroup({ email: this.email, password: this.password });
  }

  onSubmit() {
    if (this.attempts > 1) {
      if (!this.captchaSucess) {
        this.captchaError = true;
        return;
      }
    }
    if (this.loginForm.valid) {
      const email = this.email.value.toLowerCase();
      const pass = this.password.value;
      this.auth.login(email, pass)
        .subscribe(
          data => {
            var params = '&at=' + data['at'];
            params += '&redirect_to=' + data['redirect'];
            var url = data['url'] || 'http://test.smartenit.com/wordpress2';
            if (url != 'http://test.smartenit.com/wordpress2')
              window.location.href = url + '/wp-content/plugins/smartenit-wp-oauth2client/smt-login.php?option=createSession' + params;
            else {
              this.router.navigate(['home']);
              setTimeout(() => {window.location.reload();}, 500);  
            }
          },
          err => {
            if (err && err.error && err.error.errors &&
              err.error.errors.length > 0) {
              if (err.error.errors[0].attemps) {
                this.attempts = err.error.errors[0].attemps;
              }
              this.messageComponent.showError(err.error.errors[0].message);
            } else {
              this.messageComponent.showError(err);
              if (err.errors && err.errors[0] && err.errors[0].attemps) {
                this.attempts = err.error.errors[0].attemps;
              }
            }
          });
    }
  }

  private isBadCredentials(error) {
    const code = lodash.get(error, 'errors[0].code', 0);
    return code === 104 || code === 117;
  }

  resolved(captchaResponse: string) {
    this.captchaError = false;
    this.http.post('/accounts/confirmcaptcha', { response: captchaResponse }).subscribe(res => {
      if (res['success'] === true) {
        this.captchaSucess = true;
        this.captchaError = false;
      } else {
        this.captchaSucess = false;
        this.captchaError = true;
      }
    },
      msg => {

        this.captchaSucess = false;
        this.captchaError = true;
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/components/login-form/login-form.component.ts